module.exports = __webpack_public_path__ + "img/nasil_eimzatoken.ad59654e.svg";